var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"222f9ca5743caa93f93b07d94ffa276375ae2d53"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["renderchallengecom@render-challenge"]={id:"222f9ca5743caa93f93b07d94ffa276375ae2d53"};
      